

import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { LayoutTabla } from "../../layout";
import { AlertScreen } from "../components/AlertScreen";
import { separadorMillares } from "../../../helpers";
import dayjs from 'dayjs';





export const TablaCentroCostosConsumo = ({ data, chagePage=null, page=0 }) => {


    // const cambiarEstadoDoc = (e, d) => {
    //     e.stopPropagation();
    //     Swal.fire({
    //         title: `${d.estado ? 'Bloquear' : 'Desbloquear'} Centro Costo`,
    //         text: `¿Esta seguro de ${d.estado ? 'Bloquear' : 'Desbloquear'} este centro de costo.?`,
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonText: `Si, ${d.estado ? 'Bloquear' : 'Desbloquear'}` 
    //     }).then( async( result ) => {
    //         if(result.value){
    //             const resp = await startEstadoCentroCosto(d._id)
    //             if(resp){
    //                 queryClient.invalidateQueries({queryKey: ['list-cencos']});
    //             }
    //         }
    //     });
    // }


    return (

        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(50 / 50)} disabled={Math.ceil(50 / 50) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'25%'}}>Producto</TableCell>
                        <TableCell sx={{width:'15%'}}>Cantidad</TableCell>
                        <TableCell sx={{width:'15%'}}>Precio Uni.</TableCell>
                        <TableCell sx={{width:'20%'}}>Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (d) => (
                        <TableRow key={d._id}> 
                            <TableCell >{ dayjs(d.createdAt).format('DD MMM YYYY').toUpperCase() }</TableCell>
                            <TableCell >{ d.producto.nombre }</TableCell>
                            <TableCell >{ d.cantidad }</TableCell>
                            <TableCell >{`$${separadorMillares(d.precioUnitario)}`}</TableCell>
                            <TableCell >{`$${separadorMillares(d.costoTotal)}`}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        : <AlertScreen title="Este centro de costo aún no registra consumos..." />
        }
        </>
    )
}
